import { memo, useEffect } from 'react';
import Root from "./root";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";



const App = () => {

    const { i18n } = useTranslation();

    const { lng } = useParams();
	


	useEffect(() => {
        i18n.changeLanguage(lng);
    }, [App]);




	return (
        <div id={'app'} >
            <Root/>
        </div>
    )
}

export default memo(App);
